import { performOnVisaCheckoutReady } from './visa-checkout-script';

export default function visaCheckoutInit(total, currency) {
  performOnVisaCheckoutReady(function () {
    V.init({
      apikey: window.APP_CONFIG?.visaCheckout?.apiKey,
      paymentRequest: {
        currencyCode: currency,
        total: total,
      },
    });
  });
}
